import axios from "axios";

const api = axios.create({
  baseURL: "https://backend.reviewscanandgo.com/api",
});

// Export image base URL for use in components
export const IMAGE_BASE_URL = "https://backend.reviewscanandgo.com/uploads";

// Helper function to get full image URL, handling various path formats
export const getImageUrl = (imagePath) => {
  if (!imagePath) return "";
  // Remove /uploads/ prefix if it exists
  let path = imagePath.replace(/^\/uploads\//, "").replace(/^\/uploads$/, "");
  // Remove leading slash
  path = path.replace(/^\//, "");
  // Return full URL
  return `${IMAGE_BASE_URL}/${path}`;
};

// Request interceptor - Automatically attach JWT token for all requests
api.interceptors.request.use(
  (config) => {
  const token = localStorage.getItem("token");
  if (token) {
      // Ensure token is properly formatted
      const cleanToken = token.trim();
      config.headers.Authorization = `Bearer ${cleanToken}`;
  }
  return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle 401 errors (unauthorized)
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If we get a 401 (Unauthorized), the token is invalid or expired
    if (error.response?.status === 401) {
      // Clear the invalid token
      localStorage.removeItem("token");
      // Redirect to login if we're not already there
      if (!window.location.pathname.includes("/admin/login") && 
          !window.location.pathname.includes("/admin/regi-ster")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
